import { DEFAULT_PAGE_SIZE, SortDirection } from '@/components/Table/types';
import { HttpClient } from '@/core/http/http-client';
import { ApiResponse, DataWithPagination } from '@/shared/types';
import {
  AutomationRequestDetailsModel,
  AutomationRequestModel,
} from '../domain';
import {
  automationRequestDetailsMapper,
  automationRequestsWithPaginationMapper,
} from '../mappers';
import {
  ApiResponseAutomationRequests,
  AutomationRequestDetailJson,
  PagedAutomationRequests,
  UpdateRequestStageJson,
} from '../types';

export class HttpAutomationRequestRepository {
  constructor(private readonly client: HttpClient) {}

  async getAutomationRequests(
    pageNumber?: number,
    filter?: string,
    sortBy?: string,
    sortOrder?: SortDirection,
  ): Promise<DataWithPagination<AutomationRequestModel[]>> {
    const response = await this.client.get<
      ApiResponseAutomationRequests<PagedAutomationRequests>
    >({
      query: {
        pageNumber,
        rowsPerPage: DEFAULT_PAGE_SIZE,
        filter,
        sortBy,
        sortOrder,
      },
    });
    return automationRequestsWithPaginationMapper(response);
  }

  async getRequest(id: number): Promise<AutomationRequestDetailsModel> {
    const response = await this.client.get<
      ApiResponse<AutomationRequestDetailJson>
    >({
      url: `${id}`,
    });
    return automationRequestDetailsMapper(response.data.request);
  }

  async updateRequest(data: FormData): Promise<number> {
    return await this.client.put<number>(`${data.get('requestId')}`, data);
  }

  async updateRequestStage(data: UpdateRequestStageJson): Promise<unknown> {
    return await this.client.put<unknown>(`${data.id}/stage`, data);
  }

  async createAutomationRequest(data: FormData): Promise<number> {
    return await this.client.post<number>({
      body: data,
    });
  }
}
